import React from 'react';

import WingcoreBackView from '../../../main/assets/images/wingcore/wingcore-back-view.webp';

export const SecondSpecs = () => {
  return (
    <section className="wingcore-secondspecs-section">
      <img
        src={WingcoreBackView}
        alt="Back view of the device"
        className="wingcore-secondspecs-product"
      />

      <div className="wingcore-secondspecs-content">
        <div className="wingcore-secondspecs-container">
          <div className="wingcore-secondspecs-text">
            <h2 className="wingcore-secondspecs-title">MCU</h2>
            <p className="wingcore-secondspecs-subtitle">STM32H743</p>
          </div>
          <div className="wingcore-secondspecs-text">
            <h2 className="wingcore-secondspecs-title">BAROMETER</h2>
            <p className="wingcore-secondspecs-subtitle">DPS310</p>
          </div>
          <div className="wingcore-secondspecs-text">
            <h2 className="wingcore-secondspecs-title">IMU</h2>
            <p className="wingcore-secondspecs-subtitle">
              Twin (orthogonal) ICM-42688
            </p>
          </div>
          <div className="wingcore-secondspecs-text">
            <h2 className="wingcore-secondspecs-title">OSD</h2>
            <p className="wingcore-secondspecs-subtitle">
              Orqa’s custom NDAA-Compliant OSD (Text+Graphics)
            </p>
          </div>
        </div>
        <div className="wingcore-secondspecs-container">
          <div className="wingcore-secondspecs-text">
            <h2 className="wingcore-secondspecs-title">FC Software</h2>
            <p className="wingcore-secondspecs-subtitle">
              iNav, ArduPilot, PX4
            </p>
          </div>
          <div className="wingcore-secondspecs-text">
            <h2 className="wingcore-secondspecs-title">Telemetry</h2>
            <p className="wingcore-secondspecs-subtitle">SIK Radio</p>
          </div>
          <div className="wingcore-secondspecs-text">
            <h2 className="wingcore-secondspecs-title">Camera Inputs</h2>
            <p className="wingcore-secondspecs-subtitle">
              Twin analog switchable inputs
            </p>
          </div>
          <div className="wingcore-secondspecs-text">
            <h2 className="wingcore-secondspecs-title">Interfaces</h2>
            <p className="wingcore-secondspecs-subtitle">
              UART, GPIO, ADC, PWM, i2c CAN bus, USB-C
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
